import React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CompanyInfo from './components/CompanyInfo';
import InfluenceInterest from './components/InfluenceInterest';
import InfluenceLevel from './components/InfluenceLevel';
import ProfilePictureUpload from '../ProfilePictureUpload';
import enhance from './CompanySignUp.enhancer';

const steps = ['Profile Picture', 'Company', 'Influence', 'Level'];

class CompanySignup extends React.Component {
  constructor() {
    super();

    this.initialState = {
      activeStep: 0,
      companyInfo: {
        interests: [],
        targetAudience: '',
        levelOfInfluence: 'small',
        industry: '',
        mission: '',
        rating: 5,
        signUpComplete: true
      }
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.profile.isLoaded &&
      (newProps.profile.signUpComplete ||
        newProps.profile.signUpComplete === undefined)
    ) {
      this.setState({ ...this.initialState });
      this.props.history.push('/dashboard');
    }
  }

  getStepContent(step, companyInfo) {
    switch (step) {
      case 0:
        return (
          <React.Fragment>
            <Typography component="h3" variant="h5" align="center">
              First let's set up your profile picture
            </Typography>
            <ProfilePictureUpload />
            <div className={this.props.classes.buttons}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
                className={this.props.classes.nextButton}
              >
                Next
              </Button>
            </div>
          </React.Fragment>
        );

      case 1:
        return (
          <CompanyInfo
            companyInfo={companyInfo}
            changeHandler={this.handleCompanyInfoChange}
            handleBack={this.handleBack}
            handleNext={this.handleNext}
          />
        );
      case 2:
        return (
          <InfluenceInterest
            companyInfo={companyInfo}
            changeHandler={this.handleCompanyInfoChange}
            interestChange={this.handleInterestChange}
            changeHandler={this.handleCompanyInfoChange}
            handleBack={this.handleBack}
            handleNext={this.handleNext}
          />
        );
      case 3:
        return (
          <InfluenceLevel
            companyInfo={companyInfo}
            changeHandler={this.changeLevelSelection}
            handleBack={this.handleBack}
            handleFinish={() => this.props.saveProfile(this.state.companyInfo)}
          />
        );
      default:
        throw new Error('Unknown step');
    }
  }

  getHeaderContent(step, displayName) {
    switch (step) {
      case 0:
        return `Welcome aboard ${displayName}, let's set up your profile`;
      case 1:
        return `${displayName}, tell us a little about your company`;
      case 2:
        return `${displayName}, what influencers are you interested in?`;
      case 3:
        return `${displayName}, what level of influence do you need?`;
      default:
        throw new Error('Unknown step');
    }
  }

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0
    });
  };

  handleCompanyInfoChange = e => {
    this.setState({
      companyInfo: {
        ...this.state.companyInfo,
        [e.target.name]: e.target.value
      }
    });
  };

  changeLevelSelection = newSelection => {
    this.setState({
      companyInfo: {
        ...this.state.companyInfo,
        levelOfInfluence: newSelection
      }
    });
  };

  handleInterestChange = chips => {
    this.setState({
      companyInfo: {
        ...this.state.companyInfo,
        interests: chips
      }
    });
  };

  render() {
    const { classes, auth, profile, saveProfile } = this.props;
    const { activeStep, companyInfo } = this.state;

    return (
      <React.Fragment>
        <CssBaseline />
        {profile.isLoaded && (
          <main className={classes.layout}>
            <Paper className={classes.paper}>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                className={classes.headerStyle}
              >
                {this.getHeaderContent(activeStep, profile.displayName)}
              </Typography>
              <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <React.Fragment>
                {this.getStepContent(activeStep, companyInfo)}
              </React.Fragment>
            </Paper>
          </main>
        )}
      </React.Fragment>
    );
  }
}

CompanySignup.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object,
  profile: PropTypes.object,
  router: PropTypes.object,
  saveProfile: PropTypes.func
};

export default enhance(CompanySignup);



// WEBPACK FOOTER //
// ./src/components/sign-up/company/CompanySignUp.js